import React, { useContext, useEffect, useMemo, useState } from 'react';
import './ObjectViewMobile.scss';
import { IconButton } from '@material-ui/core';
import {
    FileCollectionT, ObjectContainerClientT
} from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';

import { objectTypePropertySorting } from '../../../../utils/objectType.helper';
import { Sidebar } from '../../../Wrappers';
import ObjectViewMobileDescription from './ObjectViewMobileDescription/ObjectViewMobileDescription';
import ObjectViewMobileButtons from './ObjectViewMobileButtons/ObjectViewMobileButtons';
import ObjectViewMobileImageGallery from './ObjectViewMobileImageGallery/ObjectViewMobileImageGallery';
import ObjectViewMobileFacts from './ObjectViewMobileFacts/ObjectViewMobileFacts';
import ObjectViewMobileFloorplan from './ObjectViewMobileFloorplan/ObjectViewMobileFloorplan';
import { AppContext } from '../../../../state/app.state';
import { ObosX } from '../../../../icons/obos/obosIcons';
import ReactPlayer from 'react-player';
import ObjectViewMobileDocumentModal from './ObjectViewMobileDocumentModal/ObjectViewMobileDocumentModal';
import { ToggleValuesT } from '../Desktop/ObjectView';
import ObjectViewMobileInterestFormModal from './ObjectViewMobileInterestFormModal/ObjectViewMobileInterestFormModal';
import ObjectViewMobileIframeModal from './ObjectViewMobileIframeModal/ObjectViewMobileIframeModal';



type Props = {
    className?: string;
    id?: string;
    onBackdropClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onClose?: () => void;
}

const ObjectViewMobile: React.FC<Props> = ({ onClick, onBackdropClick, onClose }) => {
    const { favoriteState, state, presentationState } = useContext(AppContext);
    const fileCollections = state?.fileCollections;
    const types = state?.project?.objectTypes;

    const selectedObject = useMemo((): ObjectContainerClientT | undefined => {
        return state?.objects?.find(o => o.id === state.selectedObjectId);
    }, [state]);

    const showObjectView = !!presentationState?.showObjectView;
    const [showIframeOne, setShowIframeOne] = useState(false);
    const [showImages, setShowImages] = useState(true);
    const [showIframeTwo, setShowIframeTwo] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [showInterestForm, setShowInterestform] = useState(false);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const isFavored = (): boolean => {
        return (!!selectedObject && !!favoriteState?.isFavored(selectedObject.id));
    };
    const [hasDesc, setHasDesc] = useState(false);

    useEffect(() => {
        setTimeout(function sendSize () {
            if (!state?.pymContextFrame) return;

            const currentHeight = document.getElementById('bv-root-element')?.clientHeight;

            currentHeight && state?.pymContextFrame?.sendHeight && state.pymContextFrame.sendHeight(currentHeight);
        }, 200);
    });

    useEffect(() => {
        const desc = selectedObject?.data?.slice()
            .filter(v => v.value !== null)
            .filter(v => types?.find(t => t.id === selectedObject.objectTypeId) ? types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => v.propId === p.id) : true)
            .sort(objectTypePropertySorting)
            .map(d => {
                const property = types?.find(t => t.id === selectedObject.objectTypeId)?.properties.find(p => p.id === d.propId);

                return ({ ...property, ...d });
            })
            .filter((d: any) => d.type === 'description' || d.type === 'richDescription');

        setHasDesc(!!desc && desc.length > 0);

    }, [selectedObject?.data, selectedObject, types]);

    const toggleFavorite = (): void => {
        if (!selectedObject) {
            return;
        }

        if (!isFavored()) {
            favoriteState?.addFavorite(selectedObject.id);
        }
        else {
            favoriteState?.removeFavorite(selectedObject.id);
        }
    };

    const toggleShow = (value: ToggleValuesT) => {
        switch (value) {
        case 'images':
            setShowImages(true);
            setShowIframeOne(false);
            setShowIframeTwo(false);
            setShowVideo(false);
            break;
        case 'iframe1':
            setShowIframeOne(true);
            break;
        case 'iframe2':
            setShowIframeTwo(true);
            break;
        case 'video':
            setShowImages(false);
            setShowIframeOne(false);
            setShowIframeTwo(false);
            setShowVideo(true);
            break;
        case 'interestform':
            setShowInterestform(true);
            break;
        default:
            setShowImages(true);
            setShowIframeOne(false);
            setShowIframeTwo(false);
            setShowVideo(false);
        }
    };

    const documentCollection = !!selectedObject?.documentCollectionId && fileCollections?.find(fC => fC.id === selectedObject.documentCollectionId);
    const videoCollection = !!selectedObject?.videoCollectionId && fileCollections?.find(fC => fC.id === selectedObject.videoCollectionId);


    const [showDescription, setShowDescription] = useState(false);

    return useObserver(() => <>{showObjectView && selectedObject && <Sidebar className={'bv-sidebar-mobile-collapsed bv-sidebar--expanded'}><div className={'bv-object-view-mobile-content bv-object-view-mobile-content--collapsed'}>
        <IconButton className={'bv-objectview-mobile-close'} onClick={(): void => {
            presentationState?.setActivePreview(false);
            toggleShow('images');
            onClose && onClose();
        }}><ObosX className={'bv-obos-x'} /></IconButton>
        <div className={'bv-object-view-mobile-content-left bv-object-view-mobile-content-left--collapsed'}>
            <div className='bv-object-view-mobile-title'>
                {types?.find(t => t.id === selectedObject?.objectTypeId)?.name || 'Lägenhet'} {selectedObject?.name}
            </div>
            <div className='bv-object-view-mobile-content-left-twocol'>
                <ObjectViewMobileFacts selectedObject={selectedObject} types={types}/>
                <ObjectViewMobileFloorplan selectedObject={selectedObject} fileCollections={fileCollections}/>
            </div>
            <div className='bv-object-view-mobile-content-bottom'>
                {hasDesc && selectedObject && <ObjectViewMobileDescription types={types} selectedObject={selectedObject} showDescription={showDescription} setShowDescription={setShowDescription} />}
                <div className='bv-object-view-mobile-content-bottom-tour'>
                    {showImages && <ObjectViewMobileImageGallery selectedObject={selectedObject} fileCollections={fileCollections}/>}
                    {showVideo && <div className='bv-object-view-mobile-tour'>
                        <ReactPlayer
                            muted
                            controls
                            playsinline
                            width={'100%'}
                            height={'100%'}
                            url={fileCollections?.find(({ id }) => id === selectedObject.videoCollectionId)?.files[0].url?.original}
                        >
                        </ReactPlayer>
                    </div>}
                </div>
            </div>
            <ObjectViewMobileDocumentModal
                showDocumentModal={showDocumentModal}
                selectedObject={selectedObject}
                fileCollections={fileCollections}
                setShowDocumentModal={setShowDocumentModal}/>
            <ObjectViewMobileInterestFormModal
                showInterestForm={showInterestForm}
                onClose={() => {
                    setShowInterestform(false);
                }}
            />
            <ObjectViewMobileIframeModal showIframeModal={showIframeOne || showIframeTwo} setShowIframeModal={(): void => {
                setShowIframeOne(false);
                setShowIframeTwo(false);
            }}>
                {showIframeOne && <iframe allowFullScreen className={'bv-object-view-mobile-tour'} src={state?.project?.tours.find(t => t.id === selectedObject.iframeOneId)?.url || ''} title='iframe' />}
                {showIframeTwo && <iframe allowFullScreen className={'bv-object-view-mobile-tour'} src={state?.project?.tours.find(t => t.id === selectedObject.iframeTwoId)?.url || ''} title='iframe' />}
            </ObjectViewMobileIframeModal>
            <ObjectViewMobileButtons
                shareButton={state?.project?.config?.shareObject}
                likeButton={state?.project?.config?.favorites}
                showIframeTwo={showIframeTwo}
                selectedObject={selectedObject}
                setShowDocumentModal={setShowDocumentModal}
                toggleShow={toggleShow}
                imageButton={!!selectedObject.imageCollectionId}
                showImage={showImages}
                showVideo={showVideo}
                videoButton={!!selectedObject.videoCollectionId && !!videoCollection && !!(videoCollection as FileCollectionT)?.files && videoCollection?.files?.length > 0}
                documentButton={!!selectedObject.documentCollectionId && !!documentCollection && !!(documentCollection as FileCollectionT)?.files && documentCollection?.files?.length > 0}
                toggleFavorite={toggleFavorite}
                isFavored={isFavored()}
                showIframeOne={showIframeOne}
                externalUrl={selectedObject.data.find(d => d.type === 'externalUrl' && d.value && d.value !== '')?.value as string | undefined}/>
        </div>
    </div></Sidebar>}
    </>
    );
};

export default ObjectViewMobile;